import { useContext, useMemo } from 'react';
import AgrConfigurationContext from '../contexts/AgrConfigurationContext';
import { ShopsService } from '../services/ShopsService';

/**
 *
 * This hook is to get an optimized (memoized) instance of a
 * ShopsService to be used in components to make API calls.
 *
 * @returns a ShopsService instance
 */
export default function useShopsService(): ShopsService {
  const config = useContext(AgrConfigurationContext);

  const shopService = useMemo(() => {
    return new ShopsService(config);
  }, [config]);

  return shopService;
}
